export class Toaster {
  id: string;
  type: string;
  message: string;
  progress?: number;

  constructor(init: Partial<Toaster>) {
    Object.assign(this, init);
  }
}
